import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Tooltip, TooltipProps, Typography } from '@mui/material';

export type ChartTitleProps = {
  title: string;
  tooltipTitle?: TooltipProps['title'];
};

export const ChartTitle = (props: ChartTitleProps) => (
  <Stack
    direction="row"
    gap="0.5rem"
    alignItems="center"
    justifyContent="center"
  >
    <Typography fontWeight="bold" variant="h6" textAlign="center">
      {props.title}
    </Typography>
    {props.tooltipTitle ? (
      <Tooltip title={props.tooltipTitle} arrow placement="top">
        <FontAwesomeIcon icon={faInfoCircle} />
      </Tooltip>
    ) : null}
  </Stack>
);
